import { LoaderFunction } from 'react-router';
import { Role } from '@ivario-arc/shared/src/enums';
import { Paths } from '@src/routes/paths';
import securedRouteLoader from '@src/auth/secured-route.loader';
import { getActiveUser } from '@src/auth/tokenRefresh';

export default (async (input) => {
  const baseLoaderResult = await securedRouteLoader(input);
  if (baseLoaderResult) {
    return baseLoaderResult;
  }
  // Already fresh after the base loader ran, so this reads the renewed session
  // rather than triggering a second renewal.
  const user = await getActiveUser();
  // eslint-disable-next-line  @typescript-eslint/no-unnecessary-condition
  const groups = (user?.profile?.groups as string[] | undefined) ?? [];
  if (
    groups.includes(Role.ADMIN) ||
    groups.includes(Role.SAMPLE_CODE_GENERATOR)
  ) {
    return null;
  } else {
    return Response.redirect(Paths.PROFILE);
  }
}) satisfies LoaderFunction;
